// TODO: REMOVE - JUST FOR QS/TESTING
import * as ReactGA from 'react-ga';
import GridShow from 'components/grid/GridShow';
import * as React from 'react';
import { connect } from 'react-redux';
import * as styles from './layout.scss';
import { withRouter } from 'react-router';
import SVGLoginIllustration from 'components/svg/LoginIllustration';
import { onUnmountLoginComponent } from 'store/login/loginActions';
import { fetchConfig } from 'store/config/configActions';
import Message from 'components/message/Message';
import Header from 'components/header/Header';
import Footer from 'components/footer/Footer';
import { Modal } from 'components/Modal';
import { getCookie } from 'utils/cookieUtils';

import { Grid, Col } from 'components/grid';
import * as colStyles from 'components/grid/col.scss';
import Internal from 'pages/error/Internal';
import { Button } from 'components/buttons';
import Selfservices from 'pages/selfservice/Selfservices';

type Props = {
	onLoginMounted?: any;
	bksToken?: any;
	userToken?: any;
	location: any;
	match: any;
	history: any;
	config?: any;
	configHasError?: boolean;
	firstLoginRedirect?: boolean | undefined;
	signType?: any;
	onUnmountLoginComponent?: any;
	firstLoginData?: any;
};

type State = {
	config: any;
	sign: any;
	login: any;
};

const trackingId = 'UA-58567623-33'; // Replace with your Google Analytics tracking ID
ReactGA.initialize(trackingId);
ReactGA.set({
	anonymizeIp: true
});

class LoginLayout extends React.Component<Props, any> {
	public constructor(props: any) {
		super(props);
		const cookie = getCookie();
		this.state = {
			loginTokenExists: false,
			cookiesAccepted: cookie.cookiesAccepted
		};
	}

	public componentWillUnmount() {
		this.props.onUnmountLoginComponent();
	}

	public componentDidMount() {
		this.props.onLoginMounted();
	}

	public reload = () => {
		window.location.reload();
	};

	public render() {
		const { config, configHasError } = this.props;
		return (
			<>
				<Modal />

				{typeof config !== 'undefined' && !configHasError && (
					<div className={styles.site}>
						<Message />
						<GridShow hide={true} zIndex={99} />

						<Header />
						<main className={styles.main}>
							<div className={styles.bgImageContainer}>
								<SVGLoginIllustration />
							</div>
							<Grid className={styles.grid}>
								<Col
									className={
										colStyles.col5Md +
										' ' +
										colStyles.col4Dt +
										' ' +
										colStyles.col3DtL +
										' ' +
										colStyles.col4DtXL +
										' ' +
										colStyles.mL6Md +
										' ' +
										colStyles.mL7Dt +
										' ' +
										colStyles.mL8DtL +
										' ' +
										colStyles.mL7DtXL
									}
								>
									<div className={styles.loginFormContainer}>
										<Selfservices />
									</div>
								</Col>
							</Grid>
						</main>
						<Footer cookiesAccepted={this.state.cookiesAccepted} />
					</div>
				)}

				{configHasError && (
					<>
						<Internal />
						<Button className={styles.retryBtn} clickHandler={this.reload}>
							Nochmal versuchen
						</Button>
					</>
				)}
			</>
		);
	}
}
const mapStateToProps = (state: State, ownProps: Props) => {
	const config = state.config.config;
	const signType = state.sign.type;
	const firstLoginRedirect = state.login.firstLoginRedirect;
	const firstLoginData = state.login.firstLoginData;

	return {
		config,
		configHasError: state.config.error,
		signType,
		firstLoginRedirect,
		firstLoginData
	};
};

const mapDispatchToProps = (dispatch: any, ownProps: Props) => ({
	onLoginMounted: () => {
		dispatch(fetchConfig());
	},

	onUnmountLoginComponent: () => {
		dispatch(onUnmountLoginComponent());
	}
});

export default withRouter<Props, any>(connect(mapStateToProps, mapDispatchToProps)(LoginLayout as any) as any);
